var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.824,
    height: 43.282,
    viewBox: "0 0 66.824 43.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12485",
    "data-name": "Group 12485",
    transform: "translate(-1602.673 113.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12484",
    "data-name": "Group 12484",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1085",
    "data-name": "Line 1085",
    x1: 4.627,
    y2: 1.301,
    transform: "translate(1604.528 -76.157)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1086",
    "data-name": "Line 1086",
    x1: 4.627,
    y2: 1.301,
    transform: "translate(1636.73 -85.474)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1087",
    "data-name": "Line 1087",
    x1: 4.627,
    y2: 1.301,
    transform: "translate(1629.11 -103.253)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1088",
    "data-name": "Line 1088",
    x1: 4.627,
    y2: 1.301,
    transform: "translate(1610.778 -72.65)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1089",
    "data-name": "Line 1089",
    x1: 4.627,
    y2: 1.301,
    transform: "translate(1632.955 -110.158)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1090",
    "data-name": "Line 1090",
    x1: 8.896,
    y2: 2.501,
    transform: "translate(1639.459 -113.187)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1091",
    "data-name": "Line 1091",
    x1: 8.896,
    y2: 2.501,
    transform: "translate(1603.189 -101.908)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1092",
    "data-name": "Line 1092",
    x1: 25.813,
    y2: 7.257,
    transform: "translate(1635.852 -85.706)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40588",
    "data-name": "Path 40588",
    d: "M1530.926,273.081l5.55,3.114-2.942,5.243",
    transform: "translate(126 -362)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40589",
    "data-name": "Path 40589",
    d: "M1508.7,274.167l16.86-4.668c7.558-2.093,5.045-8.908-6.081-6.139-6.071,1.511-23.938,6.5-35.482,9.755,0,0-8.265-6.721-9.651-6.337l-2.47.684,4.4,9.423-1.459,5.724,2.47-.684,6.72-6.509",
    transform: "translate(126 -362)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40590",
    "data-name": "Path 40590",
    d: "M1499.98,276.582l-5.814,1.61c-2.684.743-7.554.942-13.175-.108",
    transform: "translate(126 -362)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1093",
    "data-name": "Line 1093",
    x1: 4.07,
    y2: 1.127,
    transform: "translate(1650.272 -98.279)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40591",
    "data-name": "Path 40591",
    d: "M1507.771,266.287s-11.655-3.658-12.818-3.336l-3.989,1.105,5.76,5.29",
    transform: "translate(126 -362)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40592",
    "data-name": "Path 40592",
    d: "M1510.985,271.657s-9.253,10.073-10.859,10.518l-4.433,1.227,5.547-9.047",
    transform: "translate(126 -362)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1094",
    "data-name": "Line 1094",
    x1: 4.627,
    y2: 1.301,
    transform: "translate(1602.876 -98.879)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.d2a253cdceb2ec2d7c22f72b0d1433e5.svg";
export { ForwardRef as ReactComponent };